import Vue from 'vue';
const resource = '/items';

export default {
  consume(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/consume`,
      payload
    );
  },
  reception(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/reception`,
      payload
    );
  },
  orderRequests(payload) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/updateorderrequests`,
      payload
    );
  },
  updateQuantity(payload, idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/updatequantity`,
      payload
    );
  },
};
